import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { RepeatWhiteListAuthorization } from './containers/repeatWhiteListAuthorization';
import { WeChatGroupCode } from './containers/weChatGroupCode';
import { CustomerServiceCode } from './containers/customerServiceCode';
import './App.less';
import './common.less';

const history = createBrowserHistory({});

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render () {
        return (
            <Router history={history}>
                <Switch>
                    <Route path="/repeatWhiteListAuthorization" component={RepeatWhiteListAuthorization} />
                    <Route path="/weChatGroupCode" component={WeChatGroupCode} />
                    <Route path="/customerServiceCode" component={CustomerServiceCode} />
                </Switch>
            </Router>
        );
    }
}

export default App;
